import $ from "jquery";
$(window).on("load", function () {
    const accordionItems = document.querySelectorAll('.wp-block-rdts-blocks-collapsable');

    accordionItems.forEach((item) => {
        const accordionHeader = item.querySelector('.akkordeon-toggle');

        accordionHeader.addEventListener('click', () => {
            const openItem = document.querySelector('.active');
            toggleItem(item);
            // if (openItem && openItem !== item) {
            //     toggleItem(openItem);
            // }
        })
    })
    const toggleItem = (item) => {
        const accordionHeader = item.querySelector('.akkordeon-toggle');
        const accordionContent = item.querySelector('.akkordeon-section');
        if (accordionHeader.classList.contains('active')) {
            accordionContent.removeAttribute('style');
            accordionHeader.classList.remove('active');
            item.classList.remove('active');
            accordionHeader.setAttribute('aria-expanded', false);
        } else {
            accordionContent.style.height = accordionContent.scrollHeight + 'px';
            accordionHeader.classList.add('active');
            item.classList.add('active');
            accordionHeader.setAttribute('aria-expanded', true);
        }
    }
});

